import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { ReauthenticationService } from './reauthentication.service';

/** Holds a 401 response until the user signs in again, then retries the request once. */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const reauth = inject(ReauthenticationService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== HttpStatusCode.Unauthorized) {
        return throwError(() => error);
      }
      return reauth.signedIn().pipe(switchMap(() => next(req)));
    })
  );
};
